import { Clock, ArrowUpDown, DollarSign, Cpu } from "lucide-react";

interface TelemetryBadgesProps {
  telemetry?: {
    model?: string;
    latency_ms?: number;
    tokens_in?: number;
    tokens_out?: number;
    est_cost_usd?: number;
  };
}

export function TelemetryBadges({ telemetry }: TelemetryBadgesProps = {}) {
  const badges = telemetry ? [
    { 
      icon: Clock, 
      label: "Latency", 
      value: telemetry.latency_ms ? `${(telemetry.latency_ms / 1000).toFixed(1)}s` : "—" 
    },
    { 
      icon: ArrowUpDown, 
      label: "In", 
      value: telemetry.tokens_in ? `${(telemetry.tokens_in / 1000).toFixed(1)}k` : "—" 
    },
    { 
      icon: ArrowUpDown, 
      label: "Out", 
      value: telemetry.tokens_out ? `${(telemetry.tokens_out / 1000).toFixed(1)}k` : "—" 
    },
    { 
      icon: DollarSign, 
      label: "Cost", 
      value: telemetry.est_cost_usd ? `$${telemetry.est_cost_usd.toFixed(3)}` : "—" 
    },
    { 
      icon: Cpu, 
      label: "Model", 
      value: telemetry.model || "gpt-4o-mini" 
    }
  ] : [
    { icon: Clock, label: "Latency", value: "3.2s" },
    { icon: ArrowUpDown, label: "In", value: "2.1k" },
    { icon: ArrowUpDown, label: "Out", value: "0.7k" },
    { icon: DollarSign, label: "Cost", value: "$0.03" },
    { icon: Cpu, label: "Model", value: "gpt-4o-mini" }
  ];

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {badges.map((badge, index) => (
        <span
          key={index}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md border border-slate-200 bg-slate-50 text-slate-700 text-xs font-medium"
        >
          <badge.icon className="h-3 w-3" />
          <span className="hidden sm:inline">{badge.label}</span>
          <span className="font-semibold">{badge.value}</span>
        </span>
      ))}
    </div>
  );
}